import { thouShallNotPass } from '@fullstory/util/events';

const SCROLL_THRESHOLD = 50;

// Shared scroll navigation class for web and native mobile inspectors. When the correct modifier key(s) is/are held
// down, the scroll wheel navigates up and down the hierarchy and the keyboard navigates around.
export class ScrollNavigation {
  private wheelDirection: number;
  private onMouseWheel: (e: WheelEvent) => void;

  constructor(
    private window: Window,
    private modifier: ScrollModifier,
    private handler: (e: ScrollNavigationEvent) => void,
  ) {
    // Add the mousewheel handler
    this.wheelDirection = 0;
  }

  private matchesModifiers(e: any): boolean {
    // Silly Javascript - this is a type-safe way to test that the modifiers equal the current state
    return !(
      +e.shiftKey ^ +!!(this.modifier & ScrollModifier.SHIFT) ||
      +e.ctrlKey ^ +!!(this.modifier & ScrollModifier.CTRL) ||
      +e.altKey ^ +!!(this.modifier & ScrollModifier.ALT) ||
      +e.metaKey ^ +!!(this.modifier & ScrollModifier.META)
    );
  }

  public start() {
    this.onMouseWheel = (e: WheelEvent) => {
      if (!this.matchesModifiers(e)) {
        return;
      }

      // Choose the largest absolute delta - this allows shift+scroll to work on OSX
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

      if ((delta < 0 && this.wheelDirection < 0) || (delta > 0 && this.wheelDirection > 0)) {
        this.wheelDirection += delta;
      } else {
        // Direction change.
        this.wheelDirection = delta;
      }

      if (Math.abs(this.wheelDirection) >= SCROLL_THRESHOLD) {
        if (this.wheelDirection > 0) {
          this.handler(ScrollNavigationEvent.SCROLL_DOWN);
        } else {
          this.handler(ScrollNavigationEvent.SCROLL_UP);
        }
        this.wheelDirection = 0;
      }

      thouShallNotPass(e);
    };
    this.window.addEventListener('wheel', this.onMouseWheel, { passive: false });
  }

  public stop() {
    this.window.removeEventListener('wheel', this.onMouseWheel);
  }
}

export enum ScrollModifier {
  SHIFT = 1,
  CTRL = 2,
  ALT = 4,
  META = 8,
}

export enum ScrollNavigationEvent {
  SCROLL_UP,
  SCROLL_DOWN,
}
